// Country → IANA timezones, used by the Work Location modal so admins pick a
// zone from a list instead of typing one. Only the timezone is stored; the
// country is derived back from it (see countryForTimezone) when editing.
export const COUNTRY_TIMEZONES = {
  Afghanistan: ["Asia/Kabul"],
  Argentina: ["America/Argentina/Buenos_Aires", "America/Argentina/Cordoba", "America/Argentina/Mendoza"],
  Australia: [
    "Australia/Sydney",
    "Australia/Melbourne",
    "Australia/Brisbane",
    "Australia/Adelaide",
    "Australia/Darwin",
    "Australia/Perth",
    "Australia/Hobart",
  ],
  Austria: ["Europe/Vienna"],
  Bahrain: ["Asia/Bahrain"],
  Bangladesh: ["Asia/Dhaka"],
  Belgium: ["Europe/Brussels"],
  Bhutan: ["Asia/Thimphu"],
  Brazil: ["America/Sao_Paulo", "America/Manaus", "America/Fortaleza", "America/Recife", "America/Noronha"],
  Canada: [
    "America/Toronto",
    "America/Vancouver",
    "America/Edmonton",
    "America/Winnipeg",
    "America/Regina",
    "America/Halifax",
    "America/St_Johns",
  ],
  Chile: ["America/Santiago"],
  China: ["Asia/Shanghai"],
  Colombia: ["America/Bogota"],
  "Czech Republic": ["Europe/Prague"],
  Denmark: ["Europe/Copenhagen"],
  Egypt: ["Africa/Cairo"],
  Finland: ["Europe/Helsinki"],
  France: ["Europe/Paris"],
  Germany: ["Europe/Berlin"],
  Ghana: ["Africa/Accra"],
  Greece: ["Europe/Athens"],
  "Hong Kong": ["Asia/Hong_Kong"],
  Hungary: ["Europe/Budapest"],
  India: ["Asia/Kolkata"],
  Indonesia: ["Asia/Jakarta", "Asia/Makassar", "Asia/Jayapura"],
  Ireland: ["Europe/Dublin"],
  Israel: ["Asia/Jerusalem"],
  Italy: ["Europe/Rome"],
  Japan: ["Asia/Tokyo"],
  Jordan: ["Asia/Amman"],
  Kenya: ["Africa/Nairobi"],
  Kuwait: ["Asia/Kuwait"],
  Malaysia: ["Asia/Kuala_Lumpur"],
  Maldives: ["Indian/Maldives"],
  Mexico: ["America/Mexico_City", "America/Cancun", "America/Chihuahua", "America/Tijuana"],
  Nepal: ["Asia/Kathmandu"],
  Netherlands: ["Europe/Amsterdam"],
  "New Zealand": ["Pacific/Auckland"],
  Nigeria: ["Africa/Lagos"],
  Norway: ["Europe/Oslo"],
  Oman: ["Asia/Muscat"],
  Pakistan: ["Asia/Karachi"],
  Philippines: ["Asia/Manila"],
  Poland: ["Europe/Warsaw"],
  Portugal: ["Europe/Lisbon", "Atlantic/Azores"],
  Qatar: ["Asia/Qatar"],
  Romania: ["Europe/Bucharest"],
  Russia: [
    "Europe/Moscow",
    "Europe/Kaliningrad",
    "Europe/Samara",
    "Asia/Yekaterinburg",
    "Asia/Novosibirsk",
    "Asia/Krasnoyarsk",
    "Asia/Irkutsk",
    "Asia/Yakutsk",
    "Asia/Vladivostok",
  ],
  "Saudi Arabia": ["Asia/Riyadh"],
  Singapore: ["Asia/Singapore"],
  "South Africa": ["Africa/Johannesburg"],
  "South Korea": ["Asia/Seoul"],
  Spain: ["Europe/Madrid", "Atlantic/Canary"],
  "Sri Lanka": ["Asia/Colombo"],
  Sweden: ["Europe/Stockholm"],
  Switzerland: ["Europe/Zurich"],
  Taiwan: ["Asia/Taipei"],
  Thailand: ["Asia/Bangkok"],
  Turkey: ["Europe/Istanbul"],
  "United Arab Emirates": ["Asia/Dubai"],
  "United Kingdom": ["Europe/London"],
  "United States": [
    "America/New_York",
    "America/Chicago",
    "America/Denver",
    "America/Phoenix",
    "America/Los_Angeles",
    "America/Anchorage",
    "Pacific/Honolulu",
  ],
  Vietnam: ["Asia/Ho_Chi_Minh"],
};

export const COUNTRIES = Object.keys(COUNTRY_TIMEZONES).sort();

// Reverse lookup for editing an existing location, which only stores the zone.
export const countryForTimezone = (tz) =>
  COUNTRIES.find((c) => COUNTRY_TIMEZONES[c].includes(tz)) || "";

// "Asia/Kolkata" → "Kolkata (GMT+05:30)" so admins recognise the zone by city
// and offset rather than the raw IANA id.
export const timezoneLabel = (tz) => {
  const city = tz.split("/").pop().replace(/_/g, " ");
  try {
    const parts = new Intl.DateTimeFormat("en-US", {
      timeZone: tz,
      timeZoneName: "longOffset",
    }).formatToParts(new Date());
    const offset = parts.find((p) => p.type === "timeZoneName")?.value;
    return offset ? `${city} (${offset})` : city;
  } catch {
    return city;
  }
};
